import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box, useMediaQuery, useTheme } from "@mui/material";

interface IExpenseCategoryInfoSetupFieldsPanel {
	onExpenseCategorySelectionChangeHandler: (value: any) => void;
	expenseCategoryDDLItems: any

}
export const ExpenseCategoryInfoSetupFieldsPanel: FC<
	IExpenseCategoryInfoSetupFieldsPanel
> = ({ expenseCategoryDDLItems, onExpenseCategorySelectionChangeHandler }) => {

	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;


	return (
		<Box>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Expense Category"
				selectName="expenseCategory"
				testId={`expense-category`}
				labelPosition={LabelPosition.Top}
				items={expenseCategoryDDLItems ?? []}
				onSelectionChangeHandler={onExpenseCategorySelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				label="Code"
				id="code"
				testId={`code`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Label"
				id="expenseCategory"
				testId={`Expense-Category-Label`}
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			// required
			/>
			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				// placeholder="Notes"
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			/>
		</Box>
	);
};
